import { render, staticRenderFns } from "./editApproverEdit.vue?vue&type=template&id=1d55ae3c&scoped=true"
import script from "./editApproverEdit.vue?vue&type=script&lang=js"
export * from "./editApproverEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d55ae3c",
  null
  
)

export default component.exports